import { render } from "./PersonalProfile.vue?vue&type=template&id=6b31bac4&scoped=true"
import script from "./PersonalProfile.vue?vue&type=script&lang=js"
export * from "./PersonalProfile.vue?vue&type=script&lang=js"

import "./PersonalProfile.vue?vue&type=style&index=0&id=6b31bac4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b31bac4"]])

export default __exports__